import React from "react";
import Apiconsole from "../apiconsole/apiconsole";
import Apikey from "../../../Component/ApiUser/apikey";
import Createuser from "../../../Component/ApiUser/admin/createuser";
import useReactRouter from "use-react-router";
import AddcreditUser from "../../../Component/ApiUser/admin/addcreditUser";

const Userdetail = () => {
  const { match } = useReactRouter();
  return (
    <Apiconsole>
      <Apikey role="Administrator">
        {match.params.payment === "null" ? <Createuser /> : <AddcreditUser />}
      </Apikey>
    </Apiconsole>
  );
};

export default Userdetail;
